var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Hana = function Hana(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M8.276 10.477a2.581 2.581 0 0 1 4.407 1.824c0 2.64-2.14 4.781-4.782 4.781H7.52V12.302c0-.685.272-1.341.756-1.825Z",
      stroke: "none",
      className: "tw-stroke-current",
      strokeWidth: "1.44"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 3.6a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2ZM6.8 5.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Hana;